import React, { useState } from 'react'
import Title from '../../Components/Admin/Title'
import { FaRegCalendarPlus } from 'react-icons/fa6'
import MyCalendar from '../../Components/MyCalender'
import useFetchApi from '../../hooks/useFetchApi'
import { BOOKING_DATA_INSERT_ADMIN_URL, CHECK_MOBILE_URL, MANDAP_ID_PURPOSE_URL } from '../../utils/Constant'
import { authHeaders } from '../../utils/api'

function AddBooking() {
    const [showPurpose, setShowPurpose] = useState(false);
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        mandap_id: '',
        from_date: '',
        to_date: '',
        name: '',
        mobile: '',
        email: '',
        father_husband_name: '',
        relation: '',
        id_proof_id: '',
        id_proof_number: '',
        purpose_id: '',
        other_purpose: '',
        address: '',
        bank_name: '',
        branch_name: '',
        ifsc_code: '',
        account_number: '',
        remark: '',
    });

    // const url = MANDAP_ID_PURPOSE_URL;

    // const { data: mandapData } = useFetchApi({ url, dataKey: 'mandaps' });
    // const { data: purposeData } = useFetchApi({ url, dataKey: 'purposes' });
    // const { data: idProofData } = useFetchApi({ url, dataKey: 'idProofs' });

    const { data } = useFetchApi({
        url: MANDAP_ID_PURPOSE_URL
    });

    const mandapData = data?.mandaps || [];
    const purposeData = data?.purposes || [];
    const idProofData = data?.idProofs || [];

    // Check Mobile Api

    const checkMobileExists = async (mobile) => {
        try {
            const res = await fetch(CHECK_MOBILE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    mobile: mobile
                })
            });

            return await res.json();
        } catch (error) {
            console.error(error);
            return true;
        }
    };

    // Store Form data form

    const addBankingStore = async () => {
        try {
            const res = await fetch(BOOKING_DATA_INSERT_ADMIN_URL, {
                method: "POST",
                headers: authHeaders(),
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (!res.ok) {
                console.log('data:', data);
                alert("Error saving data ❌");
            } else {
                alert("Booking saved successfully ✅");
                console.log(data);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const selectedProof = idProofData.find(
        (item) => item.id == formData.id_proof_id
    );

    // ================= VALIDATE FIELD =================
    const validateField = (name, value) => {
        let error = '';

        const updatedForm = {
            ...formData,
            [name]: value
        };

        const selectedProof = idProofData.find(
            (item) => item.id == updatedForm.id_proof_id
        );

        if (name === 'name' && !value.trim()) {
            error = 'Name is required';
        }

        if (name === 'mobile') {
            if (!value) error = 'Mobile is required';
            else if (!/^\d{10}$/.test(value)) error = 'Must be 10 digits';
        }

        if (name === 'email') {
            if (!value) error = 'Email is required';
            else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                error = 'Invalid email';
            }
        }

        if (name === 'mandap_id' && !value) {
            error = 'This field is required';
        }

        // DATE VALIDATION
        if (name === 'from_date' || name === 'to_date') {

            const { from_date, to_date } = updatedForm;

            if (name === 'from_date' && !from_date) {
                error = 'From date is required';
            }

            if (name === 'to_date' && !to_date) {
                error = 'To date is required';
            }

            if (from_date && to_date) {
                if (new Date(from_date) > new Date(to_date)) {
                    if (name === 'from_date') {
                        error = 'From date must be before To date';
                    }
                    if (name === 'to_date') {
                        error = 'To date must be after From date';
                    }
                }
            }
        }

        if (name === 'father_husband_name' && !value) {
            error = 'This field is required';
        }

        if (name === 'relation' && !value) {
            error = 'This field is required';
        }

        if (name === 'id_proof_id' && !value) {
            error = 'This field is required';
        }
        if (name === 'purpose_id' && !value) {
            error = 'This field is required';
        }
        if (name === 'other_purpose' && !value && showPurpose) {
            error = 'This field is required';
        }
        if (name === 'bank_name' && !value) {
            error = 'This field is required';
        }
        if (name === 'branch_name' && !value) {
            error = 'This field is required';
        }

        // ID VALIDATION
        if (name === 'id_proof_number') {
            if (!value) {
                error = 'This field is required';
            }
            else if (selectedProof?.name?.toLowerCase().includes('aadhaar')) {
                if (!/^\d{12}$/.test(value)) {
                    error = 'Aadhaar must be 12 digits';
                }
            }
            else if (selectedProof?.name?.toLowerCase().includes('pan')) {
                const pan = value.toUpperCase();
                if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
                    error = 'Invalid PAN format';
                }
            }
        }

        if (name === 'ifsc_code') {
            const ifsc = value?.toUpperCase();

            if (!value) {
                error = 'IFSC is required';
            }
            else if (!/^[A-Z]{4}0[0-9]{6}$/.test(ifsc)) {
                error = 'Invalid IFSC format (ABCD0XXXXXX)';
            }
        }

        if (name === 'account_number') {
            if (!value) {
                error = 'Account number is required';
            }
            else if (!/^\d+$/.test(value)) {
                error = 'Only digits allowed';
            }
            else if (value.length < 9 || value.length > 18) {
                error = 'Must be 9–18 digits';
            }
        }

        return error;
    };

    // ================= ON CHANGE =================
    const onChangeInput = async (e) => {
        const { name, value } = e.target;

        const updatedForm = {
            ...formData,
            [name]: value
        };

        setFormData(updatedForm);

        let error = validateField(name, value);

        // 👉 mobile API validation
        if (name === 'mobile' && /^\d{10}$/.test(value)) {
            const result = await checkMobileExists(value);

            if (result === false) {
                error = 'Mobile already exists';
            }
        }

        // 👉 single setErrors (IMPORTANT)
        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));

        // date logic (keep as it is)
        if (name === 'from_date' || name === 'to_date') {
            const otherField = name === 'from_date' ? 'to_date' : 'from_date';

            const otherError = validateField(
                otherField,
                updatedForm[otherField]
            );

            setErrors((prev) => ({
                ...prev,
                [otherField]: otherError
            }));
        }
    };

    // ================= FORM VALIDATE =================
    const formValidate = () => {
        const tempErrors = {};

        Object.keys(formData).forEach((key) => {
            const error = validateField(key, formData[key]);
            if (error) tempErrors[key] = error;
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    // ================= SUBMIT =================
    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (formValidate()) {
    //         alert('all ok');
    //         await addBankingStore();
    //         alert('Form submitted successfully ✅');
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = formValidate();

        console.log("Form Errors:", errors); // 👈 ADD THIS

        if (isValid) {
            alert('all ok');
            await addBankingStore();
        } else {
            alert("Form has errors ❌");
        }
    };



    const onChangeInputPurpose = (e) => {
        //setFormData(e.target.value);
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));

        value === 'other' ? setShowPurpose(true) : setShowPurpose(false);

    }





    return (
        <>
            <Title icon={FaRegCalendarPlus} title='AddBooking' />
            <div className="bg-white rounded shadow-lg mt-5">
                <h4 className="text-lg p-4 font-semibold border-b flex justify-between items-center" >
                    Bookings
                    {/* <Link to="/admin/add-bookings" className='btn btn-accent btn-sm text-white shadow-md' >Add Booking</Link> */}
                </h4>

                <form onSubmit={handleSubmit}>
                    <div className="p-4 ">
                        <div className="grid grid-cols-4 gap-4 mb-3">

                            {/* 50% width */}
                            <div className="col-span-2">
                                <label className="block text-sm mb-1">Mandap</label>
                                <select
                                    className={`select select-bordered select-sm w-full ${errors.mandap_id ? 'border-secondary' : ''}`}
                                    name='mandap_id'
                                    value={formData.mandap_id}
                                    onChange={onChangeInput}
                                >
                                    <option value=''> Select Mandap</option>
                                    {mandapData.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                                {errors.mandap_id && (
                                    <p className="text-secondary text-xs mt-1">{errors.mandap_id}</p>
                                )}
                            </div>

                            {/* 25% */}
                            <div className={`col-span-1`}>
                                <MyCalendar
                                    lable="From Date"
                                    name="from_date"
                                    value={formData.from_date}
                                    onChange={onChangeInput}
                                    error={errors.from_date}
                                />
                                {errors.from_date && <p className="text-secondary text-xs mt-1">{errors.from_date}</p>}
                            </div>

                            {/* 25% */}
                            <div className="col-span-1">
                                <MyCalendar
                                    lable="To Date"
                                    name="to_date"
                                    value={formData.to_date}
                                    onChange={onChangeInput}
                                    error={errors.to_date}
                                />
                                {errors.to_date && <p className="text-secondary text-xs mt-1">{errors.to_date}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Name</label>
                                <input
                                    type="text"
                                    placeholder="Type here"
                                    name='name'
                                    onChange={onChangeInput}
                                    value={formData.name}
                                    className={`input input-bordered input-sm w-full ${errors.name ? 'border-secondary' : ''} `} />
                                {errors.name && <p className='text-secondary text-xs mt-1'>{errors.name}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Mobile</label>
                                <input
                                    type="number"
                                    placeholder="Type here"
                                    name='mobile'
                                    onChange={onChangeInput}
                                    value={formData.mobile}
                                    className={`input input-bordered input-sm w-full ${errors.mobile ? 'border-secondary' : ''}`} />
                                {errors.mobile && <p className='text-secondary text-xs mt-1'>{errors.mobile}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Email</label>
                                <input
                                    type="text"
                                    placeholder="Type here"
                                    onChange={onChangeInput}
                                    name='email'
                                    value={formData.email}
                                    className={`input input-bordered input-sm w-full ${errors.email ? 'border-secondary' : ''}`} />
                                {errors.email && <p className='text-secondary text-xs mt-1'>{errors.email}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Father/Husband</label>
                                <input
                                    type="text"
                                    name='father_husband_name'
                                    value={formData.father_husband_name}
                                    onChange={onChangeInput}
                                    placeholder="Type here"
                                    className={`input input-bordered input-sm w-full ${errors.father_husband_name ? 'border-secondary' : ''}`} />
                                {errors.father_husband_name && <p className='text-secondary text-xs mt-1'>{errors.father_husband_name}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Select Relation</label>
                                <select
                                    name='relation'
                                    value={formData.relation}
                                    onChange={onChangeInput}
                                    className={`select select-bordered select-sm w-full ${errors.relation ? 'border-secondary' : ''}`}
                                >
                                    <option value=''>Select Realation</option>

                                    <option value={'Father'}>Father</option>
                                    <option value={'Husband'}>Husband</option>

                                </select>
                                {errors.relation && <p className='text-secondary text-xs mt-1'>{errors.relation}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Id Proof</label>
                                <select
                                    name='id_proof_id'
                                    value={formData.id_proof_id}
                                    onChange={onChangeInput}
                                    className={`select select-bordered select-sm w-full ${errors.id_proof_id ? 'border-secondary' : ''}`}
                                >
                                    <option value=''>Select Id Proof</option>
                                    {idProofData.map((item) => (
                                        <option value={item.id} key={item.id}>{item.name}</option>
                                    ))}
                                </select>
                                {errors.id_proof_id && <p className='text-secondary text-xs mt-1'>{errors.id_proof_id}</p>}
                            </div>

                        </div>


                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Id Number</label>
                                <input
                                    type="text"
                                    name='id_proof_number'
                                    value={formData.id_proof_number}
                                    onChange={onChangeInput}
                                    placeholder="Id Number"
                                    className={`input input-bordered input-sm w-full ${errors.id_proof_number ? 'border-secondary' : ''}`} />
                                {errors.id_proof_number && <p className='text-secondary text-xs mt-1'>{errors.id_proof_number}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Purpose</label>
                                <select
                                    name='purpose_id'
                                    value={formData.purpose_id}
                                    onChange={onChangeInputPurpose}
                                    className={`select select-bordered select-sm w-full ${errors.purpose_id ? 'border-secondary' : ''}`}
                                >
                                    <option value=''>Select Purpose</option>
                                    {purposeData.map((item) => (
                                        <option key={item.id} value={item.id} > {item.name}</option>
                                    ))}
                                    <option value='other'>Other</option>

                                </select>
                                {errors.purpose_id && <p className='text-secondary text-xs mt-1'>{errors.purpose_id}</p>}
                            </div>

                        </div>

                        {showPurpose && (<div className="grid grid-cols-1 gap-4 mb-3">
                            <div>
                                <label className="block text-sm mb-1">Other Purpose</label>
                                <input
                                    type="text"
                                    name='other_purpose'
                                    value={formData.other_purpose}
                                    onChange={onChangeInput}
                                    placeholder="Id Number"
                                    className={`input input-bordered input-sm w-full ${errors.other_purpose ? 'border-secondary' : ''}`} />
                                {errors.other_purpose && <p className='text-secondary text-xs mt-1'>{errors.other_purpose}</p>}
                            </div>
                        </div>)}

                        <div className="grid grid-cols-1 gap-4 mb-3">
                            <div>
                                <label className="block text-sm mb-1">Address</label>
                                <textarea
                                    name='address'
                                    value={formData.address}
                                    onChange={onChangeInput}
                                    placeholder="Address"
                                    className={`textarea textarea-bordered textarea-xs w-full ${errors.address ? 'border-secondary' : ''}`} ></textarea>
                                {errors.address && <p className='text-secondary text-xs mt-1'>{errors.address}</p>}
                            </div>
                        </div>

                        <hr className="border-t-2 border-dotted my-4" />

                        <h5 className="text-lg font-semibold text-accent my-10">Account Information</h5>

                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Bank Name</label>
                                <input
                                    type="text"
                                    name='bank_name'
                                    value={formData.bank_name}
                                    onChange={onChangeInput}
                                    placeholder="Type here"
                                    className={`input input-bordered input-sm w-full ${errors.bank_name ? 'border-secondary' : ''}`} />
                                {errors.bank_name && <p className='text-secondary text-xs mt-1'>{errors.bank_name}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Barnch Name</label>
                                <input
                                    type="text"
                                    name='branch_name'
                                    value={formData.branch_name}
                                    onChange={onChangeInput}
                                    placeholder="Type here"
                                    className={`input input-bordered input-sm w-full ${errors.branch_name ? 'border-secondary' : ''}`} />
                                {errors.branch_name && <p className='text-secondary text-xs mt-1'>{errors.branch_name}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">IFSC</label>
                                <input
                                    type="text"
                                    name='ifsc_code'
                                    value={formData.ifsc_code}
                                    onChange={onChangeInput}
                                    placeholder="Type here"
                                    className={`input input-bordered input-sm w-full ${errors.ifsc_code ? 'border-secondary' : ''}`} />
                                {errors.ifsc_code && <p className='text-secondary text-xs mt-1'>{errors.ifsc_code}</p>}
                            </div>
                            <div>
                                <label className="block text-sm mb-1">Account No </label>
                                <input
                                    type="text"
                                    name='account_number'
                                    value={formData.account_number}
                                    onChange={onChangeInput}
                                    placeholder="Type here"
                                    className={`input input-bordered input-sm w-full ${errors.account_number ? 'border-secondary' : ''}`} />
                                {errors.account_number && <p className='text-secondary text-xs mt-1'>{errors.account_number}</p>}
                            </div>

                        </div>

                        <div className="grid grid-cols-1 gap-4 mb-3">

                            <div>
                                <label className="block text-sm mb-1">Remarks</label>
                                <textarea
                                    name='remark'
                                    value={formData.remark}
                                    onChange={onChangeInput}
                                    placeholder="Remarks"
                                    className="textarea textarea-bordered textarea-xs w-full "></textarea>
                            </div>


                        </div>


                        <div className="text-center">
                            <button className='btn btn-secondary btn-sm text-white'>Save</button>
                        </div>
                    </div>
                </form >
            </div >
        </>

    )
}

export default AddBooking